import { useDocumentUploader } from '@/hooks/useDocumentUploader'
import { IUploaderProps, TUploadedFile } from '@/types/uploader'
import { Alert } from '@dgshahr/ui-kit'
import FileUploader, { FileType } from '@dgshahr/ui-kit/Form/FileUploader'

const LogoUpload = ({ formik, corrections }: IUploaderProps) => {
  const { values } = formik
  const { handleUpload, handleDelete } = useDocumentUploader(formik)

  const fieldName = 'BUSINESS_LOGO'
  const files: TUploadedFile[] = values[fieldName] ?? []
  const targetFile: TUploadedFile | undefined = files.at(files.length - 1)

  const handleChange = (file: File | undefined): void => {
    if (!file) return
    handleUpload(fieldName, file)
  }
  const handleDeleteClick = (uploadedFile: TUploadedFile): void => {
    handleDelete(fieldName, uploadedFile)
  }

  return (
    <div className="flex flex-col gap-8">
      {corrections?.[fieldName] && (
        <div className="flex flex-col gap-4">
          <Alert
            size="small"
            title="اصلاحیه‌"
            variant="error"
            text={corrections[fieldName].comment}
          />
        </div>
      )}
      <label htmlFor="business-logo" className="font-p2-medium text-gray-500">
        تصویر لوگوی فروشگاه/شرکت خود را بدون بک گراند و در فرمت PNG و ابعاد
        100×100 پیکسل بارگذاری کنید.
      </label>
      <FileUploader
        className="w-fit"
        fileInputProps={{
          className: 'ss02',
          description:
            'فرمت‌های قابل قبول PNG بدون بک گراند یا SVG\nحداکثر حجم تا 5Mb',
          helperProps: {
            hintMessage: ''
          },
          title: 'تصویر لوگو',
          id: 'business-logo',
          accept:
            'image/png, image/jpeg, image/jpg, image/PNG, image/JPEG, image/JPG'
        }}
        mode="single"
        files={
          targetFile?.file || targetFile?.src
            ? (targetFile as FileType)
            : undefined
        }
        onChange={handleChange}
        previewProps={{
          leftButton: {
            onClick: (uploadedFile) =>
              handleDeleteClick(uploadedFile as TUploadedFile)
          },
          rightButton: false
        }}
      />
    </div>
  )
}

export default LogoUpload
